// AUDIO VISUAL
export const GET_AUD_VID_BY_TYPE = 'GET_AUD_VID_BY_TYPE';
export const ADD_AUD_VID = 'ADD_AUD_VID';
export const DELETE_AUD_VID = 'DELETE_AUD_VID';
export const UPDATE_AUD_VID = 'UPDATE_AUD_VID';

// OTHERS
export const GET_ARTIST = 'GET_ARTIST';
export const GET_GENRES = 'GET_GENRES';
export const GET_DIRECTORS = 'GET_DIRECTORS';
export const GET_CASTS = 'GET_CASTS';
export const GET_PLAYLISTS = 'GET_PLAYLISTS';
export const GET_PLAYLIST_BY_ID = 'GET_PLAYLIST_BY_ID';
export const ADD_PLAYLIST = 'ADD_PLAYLIST';
export const DELETE_PLAYLIST = 'DELETE_PLAYLIST';
export const UPDATE_PLAYLIST = 'UPDATE_PLAYLIST';
export const GET_PLAYLIST_ITEMS = 'GET_PLAYLIST_ITEMS';

// SERIES 
export const GET_SERIES = 'GET_SERIES';
export const GET_SERIES_BY_ID = 'GET_SERIES_BY_ID';
export const ADD_SERIES = 'ADD_SERIES';
export const DELETE_SERIES = 'DELETE_SERIES';
export const UPDATE_SERIES = 'UPDATE_SERIES';
export const GET_SERIES_GENRES = 'GET_SERIES_GENRES';
export const GET_SERIES_CASTS = 'GET_SERIES_CASTS';
export const GET_SERIES_DIRECTORS = 'GET_SERIES_DIRECTORS';
export const GET_SERIES_PLAYLISTS = 'GET_SERIES_PLAYLISTS';

// SEASONS
export const GET_SERIES_SEASONS = 'GET_SERIES_SEASONS';
export const ADD_SERIES_SEASONS = 'ADD_SERIES_SEASONS';
export const DELETE_SERIES_SEASONS = 'DELETE_SERIES_SEASONS';
export const UPDATE_SERIES_SEASONS = 'UPDATE_SERIES_SEASONS';

// EPISODES
export const ADD_SEASONS_EPISODES = 'ADD_SEASONS_EPISODES';
export const DELETE_SEASONS_EPISODES = 'DELETE_SEASONS_EPISODES';
export const UPDATE_SEASONS_EPISODES = 'UPDATE_SEASONS_EPISODES';

// PODCASTS
export const GET_PODCASTS = 'GET_PODCASTS';
export const ADD_PODCASTS = 'ADD_PODCASTS';
export const DELETE_PODCASTS = 'DELETE_PODCASTS';
export const UPDATE_PODCASTS = 'UPDATE_PODCASTS';

export const GET_PODCASTS_DIRECTORS = 'GET_PODCASTS_DIRECTORS';
export const GET_PODCASTS_TOPICS = 'GET_PODCASTS_TOPICS';
export const GET_PODCASTS_PLAYLISTS = 'GET_PODCASTS_PLAYLISTS';

// PODCASTS-EPISODES
export const GET_PODCASTS_EPISODES = 'GET_PODCASTS_EPISODES';
export const ADD_PODCASTS_EPISODES = 'ADD_PODCASTS_EPISODES';
export const DELETE_PODCASTS_EPISODES = 'DELETE_PODCASTS_EPISODES';
export const UPDATE_PODCASTS_EPISODES = 'UPDATE_PODCASTS_EPISODES';

// MEDIA FILES
export const ADD_MEDIA_FILE_ID = 'ADD_MEDIA_FILE_ID';

// STREAMER MEDIA
export const GET_STREAMER_MEDIA = 'GET_STREAMER_MEDIA';
export const DELETE_STREAMER_MEDIA = 'DELETE_STREAMER_MEDIA';